<template>
  <div>
    <!-- <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
      </a-tab-pane>
    </a-tabs> -->
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <!--          <j-dict-select-tag-->
          <!--            style="width: 170px; margin-right: 15px"-->
          <!--            placeholder="请选择年级"-->
          <!--            v-model="queryParam.gradeId"-->
          <!--            identityGet="gradeDict"-->
          <!--            :isShowEmpty="false"-->
          <!--            @select="$set(queryParam, 'classId', undefined)"-->
          <!--          />-->
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            identityGet="classDict"
            :async="true"
            :isShowEmpty="false"
          />
          <a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="提醒等级"
            dictCode="care_list"
            class="search-space"
          />
          <a-select
            v-model="queryParam.dealStatus"
            placeholder="请选择状态"
            style="width: 170px; margin-right: 15px"
            :options="followOptions"
            allowClear
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <div>
          <a-button
            type="primary"
            icon="download"
            style="margin-right: 15px"
            @click="handleExportXls('心情提醒')"
          >
            导出
          </a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="disposeRemind(record)">处理提醒</span>
          <!--          <a-divider type="vertical" />-->
          <!--          <span @click="reservePsychology(record)">预约心理老师</span>-->
          <a-divider type="vertical" />
          <span @click="viewArchives(record, 'view')">查看档案</span>
        </div>
      </template>
    </TableList>
    <InformationNote ref="informationNoteRef" />
    <DisposeRemind ref="disposeRemindRef" />
    <ReservePsychologyTeacher ref="reservePsychologyTeaRef" />
  </div>
</template>
<script>
import TableList from '@comp/chart/TableList.vue'
import { getAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal.vue'
import InformationNote from './components/InformationNote.vue'
import DisposeRemind from './components/DisposeRemind.vue'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ReservePsychologyTeacher from './components/ReservePsychologyTeacher.vue'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'RemindStuDetail',
  components: {
    TableList,
    AssessModal,
    InformationNote,
    DisposeRemind,
    ReservePsychologyTeacher,
  },
  mixins: [JeecgListMixin],
  props: {
    recordData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      dateRange: [],
      followOptions: [
        {
          value: 0,
          label: '未处理',
        },
        {
          value: 1,
          label: '已处理',
        },
      ],
      tabPaneConfig: [
        {
          tab: '',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'classId_dictText',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'studentId_dictText',
              align: 'center',
            },
            {
              title: '提醒次数',
              dataIndex: 'warnNum',
              align: 'center',
            },
            {
              title: '关爱等级',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '家长电话',
              dataIndex: 'phone',
              align: 'center',
              customRender: (_, record) => {
                return record.phone.length >= 25 ? (
                  <a-tooltip>
                    <template slot="title">{record.phone}</template>
                    {record.phone.substring(0, 25) + '...'}
                  </a-tooltip>
                ) : (
                  record.phone
                )
              },
            },
            {
              title: '提醒内容',
              dataIndex: 'tags',
              align: 'center',
            },
            {
              title: '状态',
              dataIndex: 'warnStatus',
              align: 'center',
              customRender: (_, record) => {
                return record.warnStatus === 1 ? '未处理' : '已处理'
              },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/aigoes/schoolWarnRecord/headteacherStudentWarn',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      detailModalData: [],
      disableMixinCreated: true,
    }
  },
  created() {
    if (this.recordData.keyword === 'disposalReminders') {
      this.$set(this.queryParam, 'dealStatus', 1)
    }
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/headteacherStudentWarn')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        ...this.queryParam,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    disposeRemind(record) {
      this.$refs.disposeRemindRef.showModal(record)
    },
    reservePsychology(record) {
      this.$refs.reservePsychologyTeaRef.showModal(record)
    },
    addCommunicatRecord(record, type) {
      this.$refs.informationNoteRef.showModal(record, type)
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.action-detail {
  min-width: 100px !important;
  color: #1783e8 !important;
  cursor: pointer !important;
}

.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
